import UserMenuDropdown from '@/components/UserMenuDropdown';
import * as React from 'react'
import {useModel} from 'umi';
import {Button} from 'antd';
import {QuestionCircleOutlined} from '@ant-design/icons';
import { SOLUTION_KEYS } from '@/constants/solutions';
import LeadManagementQuickActions from '../LeadManagementQuickActions';
import { F } from '@/utils/intl';
import { useIsMobile } from '@/hooks/useResponsive';
import { usePubSub } from '@/context/PubSubContext';
import { OPEN_HELP_CENTER } from '@/context/PubSubContext/events';

import styles from './index.less';

const MenuFooter: React.FC = () => {
  const {initialState} = useModel('@@initialState');
  const isMobile = useIsMobile();
  const { publish } = usePubSub();

  return (
    <div>
      {initialState.selectedSolution === SOLUTION_KEYS.LEAD_MANAGEMENT && (
        <LeadManagementQuickActions />
      )}
      {/* The help centre's floating button is hidden on phones (it covered
          content), so the nav drawer carries the entry point instead. */}
      {isMobile && (
        <Button
          type="text"
          block
          className={styles.helpMenuItem}
          icon={<QuestionCircleOutlined />}
          onClick={() => publish(OPEN_HELP_CENTER, {})}
        >
          <F id={'helpCenter.title'} defaultMessage={'Help Center'} />
        </Button>
      )}
    </div>
  );
}

export default (MenuFooter)
